import React from 'react';

import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

import ClassSubmitButtons from './ClassSubmitButtons';
import { useAppMessaging } from '../../hooks/useAppMessaging';

const Container = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin: 1rem 0 0;
`;

const StyledButton = styled(Button)`
    margin-left: 0.75rem;
`;

export interface PublishButtonProps {
    onClose?: () => void;
    onSuccess?: () => void;
    admin?: boolean;
}

const ClassFormFooter = (props: PublishButtonProps) => {
    const { onSuccess, onClose, admin = false } = props;

    const { closeWindow } = useAppMessaging();

    const { t } = useTranslation('create_edit_class');

    const handleCancel = () => {
        // always send 'close' message to parent window
        closeWindow();

        onClose?.();
    };

    return (
        <Container>
            <StyledButton onClick={handleCancel} variant="outlined">
                {t('cancel')}
            </StyledButton>
            <ClassSubmitButtons onSuccess={onSuccess} admin={admin} />
        </Container>
    );
};

export default ClassFormFooter;
